const MS_PER_SEC = 1000;
const SEC_PER_MIN = 60;
const MIN_PER_HR = 60;
const HR_PER_DAY = 24;

export const MS_PER_DAY = MS_PER_SEC * SEC_PER_MIN * MIN_PER_HR * HR_PER_DAY;

export const getFormattedDateString = (d) => {
  const isoString = d.toISOString();
  return isoString.split('T')[0];
};

export const DATE_FORMAT = 'MM/dd/yyyy';
export const API_DATE_FORMAT = 'yyyy-MM-dd';
